<ng-container>
  <ng-container>
    <div>
      <div class="col-lg-12" *ngIf="!isModal">
        <div>
          <span
            class="d-flex justify-content-between align-items-center pt-2 pb-2 mb-2 globalborder-btm-header">
            <span class="col-auto">
              <h2 class="mb-0">PDF</h2>
            </span>
            <span class="col-auto">
              <span class="cross-border" (click)="closePdfStacker()"
                ><i class="pi pi-times"></i
              ></span>
            </span>
          </span>
        </div>
      </div>
      <div class="row g-3 align-items-stretch pdf-chat-row pt-3">
        <div
          class="pdf-viewer-pane"
          [ngClass]="showChat ? 'col-7 col-xl-8 mt-0 ps-0' : 'col-12'">
          <ng-container *ngIf="isImageFile; else pdfViewer">
            <img
              [src]="'data:' + imageMimeType + ';base64,' + base64pdf"
              class="img-fluid w-100 h-100 object-fit-contain"
              [alt]="fileNameToDownload"
              style="max-height: 75vh" />
          </ng-container>
          <ng-template #pdfViewer>
            <ngx-extended-pdf-viewer
              [base64Src]="base64pdf"
              [textLayer]="true"
              [showHandToolButton]="true"
              [showPresentationModeButton]="true"
              [filenameForDownload]="fileNameToDownload"
              height="75vh">
            </ngx-extended-pdf-viewer>
          </ng-template>
        </div>

        <div class="col-5 col-xl-4 mt-0 chat-column px-0" *ngIf="showChat">
          <div class="chat-pane w-100 d-flex flex-column overflow-hidden">
            <div
              class="chat-header d-flex align-items-center justify-content-between">
              <div
                class="chat-title fw-semibold fs-5 d-flex align-items-center gap-2">
                Chat
                <span class="chat-badge fw-medium"
                  >{{ chatMessages.length }} messages</span
                >
              </div>
            </div>

            <div
              #chatBody
              class="chat-body overflow-auto p-3 d-flex flex-column">
              <div
                *ngIf="chatLoading && chatMessages.length === 0"
                class="text-center text-muted py-3">
                Loading conversation...
              </div>
              <div
                *ngIf="!chatLoading && chatMessages.length === 0"
                class="text-center text-muted py-3">
                No messages yet.
              </div>

              <ng-container
                *ngFor="let msg of chatMessages; trackBy: trackByMessageId">
                <!-- incoming message -->
                <div class="d-flex gap-2" *ngIf="!msg.outgoing">
                  <div
                    class="chat-avatar rounded-circle fw-semibold d-flex align-items-center justify-content-center">
                    {{ msg.initials }}
                  </div>
                  <div
                    class="chat-message-content d-flex flex-column gap-1 flex-grow-1">
                    <div
                      class="chat-message-meta d-flex align-items-center gap-2 justify-content-between">
                      <span class="chat-sender fw-semibold">{{
                        msg.sender
                      }}</span>
                      <span class="chat-time">{{ msg.timestamp }}</span>
                    </div>
                    <div class="chat-bubble d-flex flex-column gap-2">
                      <div *ngIf="msg.body">{{ msg.body }}</div>
                      <div
                        *ngIf="msg.statusLabel"
                        class="status rounded-pill py-1 px-2 incoming d-flex align-items-center gap-1"
                        [ngClass]="{
                          'status-approved': msg.proofStatus === 2,
                          'status-change': msg.proofStatus === 3,
                          'status-pending': msg.proofStatus === 1,
                        }">
                        <span class="chat-status-dot rounded-circle"></span>
                        {{ msg.statusLabel }}
                      </div>
                      <button
                        *ngIf="msg.fileName"
                        type="button"
                        class="chat-file d-flex align-items-center gap-2 p-2 border-0 cursor-pointer"
                        (click)="downloadChatFile(msg)"
                        [title]="'Download ' + msg.fileName">
                        <span class="chat-file-icon"></span>
                        <span>{{ msg.fileName }}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- outgoing message -->
                <div
                  class="chat-message outgoing d-flex gap-2"
                  *ngIf="msg.outgoing">
                  <div class="chat-message-content d-flex flex-column gap-1">
                    <div
                      class="chat-message-meta d-flex align-items-center gap-2 justify-content-end">
                      <span class="chat-sender fw-semibold">{{
                        msg.sender
                      }}</span>
                      <span class="chat-time">{{ msg.timestamp }}</span>
                    </div>
                    <div
                      class="chat-bubble chat-bubble-outgoing d-flex flex-column gap-2">
                      <div *ngIf="msg.body">{{ msg.body }}</div>
                      <div
                        *ngIf="msg.statusLabel"
                        class="status rounded-pill py-1 px-2 outgoing d-flex align-items-center gap-1">
                        <span
                          class="chat-status-dot rounded-circle"
                          [ngClass]="{
                            'status-approved': msg.proofStatus === 2,
                            'status-change': msg.proofStatus === 3,
                            'status-pending': msg.proofStatus === 1,
                          }"></span>
                        {{ msg.statusLabel }}
                      </div>
                      <button
                        *ngIf="msg.fileName"
                        type="button"
                        class="chat-file chat-file-outgoing d-flex align-items-center gap-2 p-2 border-0 cursor-pointer"
                        (click)="downloadChatFile(msg)"
                        [title]="'Download ' + msg.fileName">
                        <span class="chat-file-icon-outgoing"></span>
                        <span>{{ msg.fileName }}</span>
                      </button>
                    </div>
                  </div>
                  <div
                    class="chat-avatar outgoing-avatar rounded-circle fw-semibold d-flex align-items-center justify-content-center">
                    {{ msg.initials }}
                  </div>
                </div>
              </ng-container>
            </div>

            <div
              class="chat-footer d-flex align-items-center p-3"
              *ngIf="canResubmit">
              <div
                class="chat-input-wrap d-flex align-items-center gap-2"
                [class.chat-input-invalid]="
                  messageAttempted && !message.trim()
                ">
                <!-- <label
                  class="mb-0 d-flex align-items-center"
                  title="Attach revised proof">
                  <i class="pi pi-paperclip"></i>
                  <input
                    type="file"
                    class="d-none"
                    accept=".pdf,.png,.jpg,.jpeg"
                    (change)="onFileSelected($event)" />
                </label> -->
                <input
                  type="text"
                  placeholder="Type a message..."
                  [(ngModel)]="message"
                  [attr.aria-invalid]="messageAttempted && !message.trim()" />
              </div>
              <span
                *ngIf="selectedFile"
                class="chat-file-size text-truncate"
                [title]="selectedFile.name"
                >{{ selectedFile.name }}</span
              >
              <input
                #proofFileInput
                type="file"
                class="d-none"
                accept=".pdf,.png,.jpg,.jpeg"
                (change)="onFileSelected($event)" />
              <button
                type="button"
                class="chat-upload-btn border-0"
                [class.chat-upload-btn-dragover]="isDragOver"
                title="Click or drop a file to attach"
                (click)="proofFileInput.click()"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)">
                <i class="pi pi-upload"></i>
              </button>
              <button
                type="button"
                class="chat-resubmit-btn py-2 px-3"
                [disabled]="resubmitting"
                (click)="onResubmit()">
                {{ resubmitting ? "Resubmitting..." : "Resubmit" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
